/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { teamLookupResponseSchema } from './teamLookupResponseSchema';

export const pageResponseTeamLookupResponseSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(teamLookupResponseSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
